<template>
  <div>

    <c-title>Seite nicht gefunden</c-title>

    <p>Diese Seite wurde leider nicht gefunden. Vielleicht helfen die folgenden Links weiter:</p>

    <ul>
      <li>
        <router-link :to="{ name: 'dashboard' }">
          Dashboard
        </router-link>
      </li>
      <li>
        <a
          href="https://www.claussen-simon-stiftung.de/de/legal/kontakt/"
          rel="noopener"
          target="_blank"
        >
          Kontaktformular
        </a>
      </li>
      <li>
        <a
          href="https://www.claussen-simon-stiftung.de/de/aktuelles/newsletter/"
          rel="noopener"
          target="_blank"
        >
          Newsletter
        </a>
      </li>
      <li>
        <a
          href="https://www.claussen-simon-stiftung.de/de/aktuelles/"
          rel="noopener"
          target="_blank"
        >
          Aktuelles
        </a>
      </li>
      <li>
        <a
          href="https://www.claussen-simon-stiftung.de/de/stiftung/impressum/"
          rel="noopener"
          target="_blank"
        >
          Impressum & Datenschutz
        </a>
      </li>
    </ul>

  </div>
</template>

<script>
import CTitle from '@/components/CTitle'

export default {
  name: 'VError',

  components: {
    CTitle
  }
}
</script>
